<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15qDnzv/tc-custom/9781644031711.jpg?1733122762438" alt="This image is the cover for the book Jump Into Sewing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jump Into Sewing
      </h1>
      <p class="bookDescription body article font2">
        <p>Learn the art of sewing Beginners rejoice—getting started with sewing has never been easier! This project-based introductory guide will give you everything you need to know to explore and enjoy this fun art form. Dive in and sew six cute and useful projects like pillows, totes, pouches, and more. Plus, learn about the basics anatomy of a sewing machine, fabric, thread, and needle guide, and all the helpful tools and supplies you need. While this book is ideal for beginners, the adorable designs are still perfect and enjoyable for all sewing enthusiasts!   Sewing beginners delve into 6 versatile projects with step-by-step instructions Includes comprehensive information on tools needed plus tips and tricks Part of our “Jump into” series—you’ve bought your sewing machine, now make the most of it</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Chappell Monroe
      </h2>
      
      <p class="authorDescription body article">Lee Monroe is an instructor, designer, and well-loved quilter who designs under the brand May Chappell. Lee is known for her clean and innovative modern quilts and her thorough and easy-to-understand instruction. She lives in Winston-Salem, NC. maychappell.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f064a18